import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';

export default function LogoSection({ reverse, isIcon, sx, to }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
  return (
    <Box sx={{ ...sx, display: 'inline-flex', alignItems: 'center', cursor: 'default' }}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </Box>
  );
  }

  return (
    <ButtonBase disableRipple component={Link} to={to || '/dashboard'} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
